var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.32084 18.2435H2.88494C2.56192 18.2435 2.25213 18.1092 2.02372 17.87C1.79531 17.6309 1.66699 17.3066 1.66699 16.9684V2.94211C1.66699 2.60393 1.79531 2.2796 2.02372 2.04047C2.25213 1.80133 2.56192 1.66699 2.88494 1.66699H16.2824C16.6054 1.66699 16.9152 1.80133 17.1436 2.04047C17.372 2.2796 17.5003 2.60393 17.5003 2.94211V16.9684C17.5003 17.3066 17.372 17.6309 17.1436 17.87C16.9152 18.1092 16.6054 18.2435 16.2824 18.2435H13.8465M1.66699 5.49265H17.5003M9.58311 18.2424V9.95416M9.58311 9.95416L6.53911 13.142M9.58311 9.95416L12.6288 13.142",
    stroke: "#AA1A5F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.f148fe78ab57278cdac8890a7e94d651.svg";
export { ForwardRef as ReactComponent };